import { AiSuiteTool, aiColors } from '@euler/app/flows/ai-suite/theme';
import { AiAgentBundleId, AiHomeFeature } from '@euler/model/ai-home';
import {
  ArrowUpToLine,
  CalendarDays,
  ChartColumnIncreasing,
  LayoutDashboard,
} from 'lucide-react-native';

/** The chat on a dashboard: its chip, empty state and composer hint. */
export const kBiDashboardChatTool: AiSuiteTool = {
  kind: 'chat',
  feature: AiHomeFeature.BusinessIntelligence,
  title: '看板助手',
  subtitle: '用一句话调整看板',
  color: aiColors.amber,
  icon: LayoutDashboard,
  bundleId: AiAgentBundleId.Workshop,
  heading: '想怎么调整这个看板？',
  intro: '我会先在看板上预览修改，你确认后才会应用。',
  placeholder: '想怎么调整这个看板…',
  starters: [
    { text: '把图表都改成按周显示', icon: CalendarDays, color: aiColors.blue },
    { text: '把指标卡放到最上面', icon: ArrowUpToLine, color: aiColors.green },
    {
      text: '加一张本月服务项目前十的图表',
      icon: ChartColumnIncreasing,
      color: aiColors.violet,
    },
  ],
};
